import React, { useEffect, useMemo, useState } from "react";
import { TeaserCard } from "@/components/TeaserCard";

const SPECIAL = {
  "25-09": [
    "On 25 Sept 1066, Harold won at Stamford Bridge ending the Viking Age. On 25 Sept 1957, the Little Rock Nine walked into school. Two battles for England & America — 891 years apart, same date.",
    "Birthday twins: Michael Douglas (1944) and Catherine Zeta-Jones (1969) were both born on 25 Sept, 25 years apart — and married each other.",
    "On this day in 1690 America's first newspaper lasted 1 issue before being banned. On this day in 1956, the first transatlantic phone cable let America call the world.",
    "Sequoia trees protected in 1890 on 25 Sept are older than every other event on this page — some were alive when Harold fought Vikings in 1066.",
  ],
};

const buildPairs = (events, ddmm) => {
  const pairs = [];
  const ev = (events || []).filter((e) => e.year && e.event_title);
  for (let i = 0; i < ev.length; i++) {
    for (let j = i + 1; j < ev.length; j++) {
      if (ev[i].category === ev[j].category && ev[i].event_title !== ev[j].event_title) {
        const gap = Math.abs(Number(ev[j].year) - Number(ev[i].year));
        pairs.push(`Two ${String(ev[i].category).toLowerCase()} milestones share this date — ${ev[i].event_title} (${ev[i].year}) and ${ev[j].event_title} (${ev[j].year}), ${gap} years apart.`);
      }
    }
  }
  const shuffled = pairs.sort(() => 0.5 - Math.random()).slice(0, 10);
  return [...(SPECIAL[ddmm] || []), ...shuffled];
};

export const CoincidenceEngine = ({ events, ddmm }) => {
  const [index, setIndex] = useState(0);
  const items = useMemo(() => buildPairs(events, ddmm), [events, ddmm]);

  useEffect(() => { setIndex(0); }, [items]);
  useEffect(() => {
    const id = setInterval(() => setIndex((i) => i + 1), 7000);
    return () => clearInterval(id);
  }, []);

  const current = items.length ? items[index % items.length] : "Pick a date to spin up its coincidences.";

  return (
    <TeaserCard
      glyph="∞"
      title="Coincidence Engine"
      testid="coincidence-engine"
      cta="Spin coincidence →"
      ctaTestid="coincidence-spin"
      onCta={() => setIndex((i) => i + 1)}
      subtext={items.length ? `${(index % items.length) + 1} / ${items.length} coincidences found today • Auto-spins every 7s` : "No coincidences yet"}
    >
      <p key={index} data-testid="coincidence-text" className="animate-in fade-in duration-500 text-ink">{current}</p>
    </TeaserCard>
  );
};
